module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/begambleaware-34bfde646c07db98.png"+" 120w",
        images: [{path: __webpack_public_path__ + "assets/images/begambleaware-34bfde646c07db98.png",width: 120,height: 16}],
        src: __webpack_public_path__ + "assets/images/begambleaware-34bfde646c07db98.png",
        toString: function(){return __webpack_public_path__ + "assets/images/begambleaware-34bfde646c07db98.png"},
        
        width: 120,
        height: 16
      }